export default "__VITE_ASSET__gVkwGhCA__"